import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "video-translate-page"
};
const _hoisted_2 = {
  class: "video-translate-operation-panel page-panel"
};
const _hoisted_3 = {
  class: "video-translate-operation-main"
};
const _hoisted_4 = {
  class: "video-translate-operation-controller"
};
const _hoisted_5 = {
  class: "video-translate-upload-box video-translate-box"
};
const _hoisted_6 = {
  class: "uploader-preview-box dark-border"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "video-translate-selector-box video-translate-box"
};
const _hoisted_9 = {
  class: "video-translate-selector-item"
};
const _hoisted_10 = {
  class: "video-translate-selector-input"
};
const _hoisted_11 = {
  class: "video-translate-selector-item settings-section"
};
const _hoisted_12 = {
  class: "settings-content"
};
const _hoisted_13 = {
  class: "settings-item"
};
const _hoisted_14 = {
  key: 0,
  class: "settings-item"
};
const _hoisted_15 = {
  class: "settings-item"
};
const _hoisted_16 = {
  class: "settings-item"
};
const _hoisted_17 = {
  class: "video-translate-submit-box video-translate-box"
};
const _hoisted_18 = {
  class: "video-translate-table-panel page-panel"
};
const _hoisted_19 = {
  class: "preview-video-container"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "video-translate-operation-panel-mask"
};
const _hoisted_22 = {
  class: "image-container"
};
import { ref, reactive, computed, onUnmounted } from "vue";
import ApplicationPage from '@/components/ApplicationPage/index.vue';
import { UploadFilled, Comment, SuccessFilled, Promotion } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox, ElButton } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/button/style/index'

import { dubbingGetLanguages } from '@/request/multilingual';
import { dubbingVideo, dubbingVideoPage, deleteDubbing } from "@/request/appCenter";
import { blobDownloadUpgrades } from "@/utils";
import { PollingTimer } from "@/utils/pollingTimer";
import DirectUploader from "@/components/DirectUploader/index.vue";
import { copyText } from '@/utils/index';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    let blobDownload = (item, type) => {
      let name = item.mediaName.replace(/[<>.:"/\\|?*\x00-\x1F]/g, '');
      if (type === '视频') {
        blobDownloadUpgrades(item.dubbingFile, name + langMaps.value[item.targetLang] + '.mp4');
      }
      if (type === '音频') {
        blobDownloadUpgrades(item.audioUrl, name + langMaps.value[item.targetLang] + '.mp3');
      }
      if (type === '字幕') {
        blobDownloadUpgrades(item.subtitleUrl, name + langMaps.value[item.targetLang] + '.srt');
      }
    };
    let copyItemUrl = item => {
      const textParts = [];
      if (item !== null && item !== void 0 && item.dubbingFile) {
        textParts.push(`视频地址:${item.dubbingFile}`);
      }
      if (item !== null && item !== void 0 && item.audioUrl) {
        textParts.push(`音频地址:${item.audioUrl}`);
      }
      if (item !== null && item !== void 0 && item.subtitleUrl) {
        textParts.push(`字幕地址:${item.subtitleUrl}`);
      }
      const text = textParts.join(';');
      copyText(text);
    };
    const uploadLoading = ref(false);
    const upgrade = ref(false);
    const videoUrl = ref("");
    const videoName = ref("");
    const langList = ref([]);
    const targetLang = ref("");
    let langForm = ref({
      isSubtitles: false,
      bgMusic: true,
      isSubtitlesBg: false,
      wavlip: false //口型
    });
    const historyData = ref([]);
    const searchParams = reactive({
      pageIndex: 1,
      pageSize: 10
    });
    const total = ref(0);
    const dialogVisible = ref(false);
    const previewVideoUrl = ref("");
    const videoUploaderButton = ref(null);
    const submitLoading = ref(false);
    const langMaps = computed(() => {
      return langList.value.reduce((res, item) => {
        res[item.value] = item.label;
        return res;
      }, {});
    });
    const statusMaps = {
      1: {
        statusLabel: "生成中",
        statusType: "info"
      },
      2: {
        statusLabel: "生成成功",
        statusType: "success"
      },
      3: {
        statusLabel: "生成失败",
        statusType: "danger"
      },
      4: {
        statusLabel: "生成中",
        statusType: "info"
      }
    };
    const handleBeforeUpload = async rawFile => {
      // 限制上传文件大小小于100M 
      if (rawFile.size / 1024 / 1024 > 100) {
        ElMessage({
          type: 'error',
          message: '上传文件大小不能超过100M'
        });
        return false;
      }
      // 判断上传视频为mp4
      if (rawFile.type !== 'video/mp4') {
        ElMessage({
          type: 'error',
          message: '只能上传mp4格式的视频'
        });
        return false;
      }
      uploadLoading.value = true;
      return true;
    };
    let handleSuccess = async res => {
      uploadLoading.value = false;
      const {
        code,
        data
      } = res;
      if (code === 200) {
        videoUrl.value = data.url;
        videoName.value = data.originalFilename;
      } else {
        handleError();
      }
    };
    const handleError = () => {
      uploadLoading.value = false;
      ElMessage({
        type: 'error',
        message: '上传失败'
      });
    };
    async function updateOptions(dubbingMode) {
      try {
        var _res$data, _targetLangList$;
        const res = await dubbingGetLanguages(dubbingMode);
        const targetLangList = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.data) === null || _res$data === void 0 ? void 0 : _res$data.targetLangList) || [];
        langList.value = targetLangList.map(item => ({
          value: item.value,
          label: item.name
        }));
        targetLang.value = ((_targetLangList$ = targetLangList[0]) === null || _targetLangList$ === void 0 ? void 0 : _targetLangList$.value) || '';
      } catch (error) {
        console.error('Error fetching languages:', error);
      }
    }
    const getData = async () => {
      const res = await dubbingVideoPage(searchParams);
      const {
        code,
        data
      } = res.data;
      if (code == 200) {
        historyData.value = data.list.map(d => ({
          ...d,
          ...statusMaps[d.status]
        }));
        total.value = data.total;
        return true;
      } else {
        return false;
      }
    };
    const handleCurrentChange = pageIndex => {
      searchParams.pageIndex = pageIndex;
      getData();
    };
    const handleSizeChange = pageSize => {
      searchParams.pageSize = pageSize;
      searchParams.pageIndex = 1;
      getData();
    };
    const resetUpload = () => {
      videoUrl.value = "";
      videoName.value = "";
      uploadLoading.value = false;
      searchParams.pageIndex = 1;
    };
    const submitVideoTranslate = async () => {
      if (!videoUrl.value) return ElMessage.error('请先上传视频');
      if (!targetLang.value) return ElMessage.error('请先选择目标语言');
      submitLoading.value = true;
      const res = await dubbingVideo({
        dubbingMode: "ims",
        media: videoUrl.value,
        targetLang: targetLang.value,
        mediaType: "mp4",
        mediaName: videoName.value,
        ...langForm.value
      }).finally(() => submitLoading.value = false);
      if (res.data.code == 200) {
        ElMessage.success({
          showClose: true,
          message: '提交成功，请在下方列表查看任务状态',
          duration: 5000
        });
        resetUpload();
        getData();
      }
    };
    const handleDelete = id => {
      ElMessageBox.confirm('确定要删除该视频吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deleteDubbing(id);
        if (res.data.code == 200) {
          ElMessage.success('删除成功');
          getData();
        }
      });
    };
    const previewVideo = url => {
      previewVideoUrl.value = url;
      dialogVisible.value = true;
    };
    const handleClosed = () => {
      previewVideoUrl.value = "";
    };
    const callUpload = () => {
      if (videoUploaderButton.value) {
        var _videoUploaderButton$;
        (_videoUploaderButton$ = videoUploaderButton.value) === null || _videoUploaderButton$ === void 0 || (_videoUploaderButton$ = _videoUploaderButton$.ref) === null || _videoUploaderButton$ === void 0 || _videoUploaderButton$.click();
      }
    };
    updateOptions('ims');
    const updateData = async () => {
      const stopPolling = await getData();
      // 如果接口错误，则停止轮询
      return !stopPolling;
    };
    let timer = new PollingTimer(updateData, 5 * 1000);
    timer.start();
    onUnmounted(() => {
      timer.cancel();
    });
    return (_ctx, _cache) => {
      const _component_el_step = _resolveComponent("el-step");
      const _component_el_steps = _resolveComponent("el-steps");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_Download = _resolveComponent("Download");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_image = _resolveComponent("el-image");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(ApplicationPage, {
        "app-name": "视频多语言翻译"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "title-with-line"
        }, "立即尝试", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_steps, {
          class: "video-translate-operation-steps",
          "align-center": "",
          active: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_step, {
            title: "上传视频",
            icon: _unref(UploadFilled)
          }, null, 8, ["icon"]), _createVNode(_component_el_step, {
            title: "选择语言",
            icon: _unref(Comment)
          }, null, 8, ["icon"]), _createVNode(_component_el_step, {
            title: "立即转换",
            icon: _unref(SuccessFilled)
          }, null, 8, ["icon"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [videoUrl.value ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          class: "uploader-preview-video",
          src: videoUrl.value,
          controls: ""
        }, null, 8, _hoisted_7)) : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          class: "uploader-preview-desc",
          "image-size": 60,
          description: "点击上传视频",
          onClick: callUpload
        }, null, 512)), [[_directive_loading, uploadLoading.value]])]), _withDirectives((_openBlock(), _createBlock(DirectUploader, {
          class: "video-translate-uploader",
          "show-file-list": false,
          "before-upload": handleBeforeUpload,
          "on-success": _unref(handleSuccess),
          "on-error": handleError,
          accept: ".mp4"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            ref_key: "videoUploaderButton",
            ref: videoUploaderButton
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(videoUrl.value ? "重新上传" : "点击上传"), 1)]),
            _: 1
          }, 512)]),
          _: 1
        }, 8, ["on-success"])), [[_directive_loading, uploadLoading.value]])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "video-translate-selector-title"
        }, "选择目标语言类型：", -1)), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langList.value, lang => {
          return _openBlock(), _createBlock(_component_el_tag, {
            key: lang.value,
            class: _normalizeClass(["video-translate-selector-input-item", {
              'is-active': lang.value === targetLang.value
            }]),
            size: "large",
            type: lang.value === targetLang.value ? 'primary' : 'info',
            onClick: $event => targetLang.value = lang.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(lang.label), 1)]),
            _: 2
          }, 1032, ["class", "type", "onClick"]);
        }), 128))])]), _createElementVNode("div", _hoisted_11, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "settings-header"
        }, "额外设置", -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_form_item, {
          label: "视频是否添加字幕:",
          class: "form-item-custom"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: _unref(langForm).isSubtitles,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(langForm).isSubtitles = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: true
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("是")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: false
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("否")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "settings-tip"
        }, "选择\"是\"将在视频中显示字幕；选择\"否\"则不做调整。", -1))]), _unref(langForm).isSubtitles ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_el_form_item, {
          label: "视频字幕背景:",
          class: "form-item-custom"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: _unref(langForm).isSubtitlesBg,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(langForm).isSubtitlesBg = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: true
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("黑色背景")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: false
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("不做调整")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "settings-tip warning"
        }, "注意: 不做调整可能会出现与原视频字幕重叠的情况", -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_form_item, {
          label: "视频是否保留背景音乐:",
          class: "form-item-custom"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: _unref(langForm).bgMusic,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(langForm).bgMusic = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: true
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("是")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: false
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("否")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "settings-tip warning"
        }, "注意: 需要确保视频背景中有音乐才能选择\"是\"，否则转换的视频可能出现异常。", -1))]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_form_item, {
          label: "口型校对:",
          class: "form-item-custom"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: _unref(langForm).wavlip,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(langForm).wavlip = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: true
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("是")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: false
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("否")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "settings-tip"
        }, "选“是”优化口型字幕匹配，需保证视频里人物全程出现；“否”则不做调整。", -1))])])])]), _createElementVNode("div", _hoisted_17, [_createVNode(_unref(ElButton), {
          class: "video-translate-submit-btn",
          icon: _unref(Promotion),
          size: "large",
          type: "primary",
          onClick: submitVideoTranslate
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("立即转换")])),
          _: 1
        }, 8, ["icon"])])])])])), [[_directive_loading, submitLoading.value]]), _createElementVNode("div", _hoisted_18, [_cache[30] || (_cache[30] = _createElementVNode("div", {
          class: "title-with-line"
        }, "历史生成", -1)), _createVNode(_component_el_table, {
          class: "history-table",
          data: historyData.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "mediaName",
            label: "文件名称"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              type: "primary",
              onClick: $event => previewVideo(scope.row.media)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.mediaName), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "targetLang",
            label: "目标语言"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(langMaps.value[scope.row.targetLang]), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "status",
            label: "状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_tag, {
              type: scope.row.statusType || 'warning'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.statusLabel || "未知状态"), 1)]),
              _: 2
            }, 1032, ["type"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间"
          }), _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "300"
          }, {
            default: _withCtx(scope => [_createVNode(_unref(ElButton), {
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => handleDelete(scope.row.id)
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("删除")])),
              _: 2
            }, 1032, ["onClick"]), scope.row.status == 2 ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => previewVideo(scope.row.dubbingFile)
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("预览")])),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), false ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              link: "",
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("下载")])),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
              style: {
                "line-height": "0",
                "margin": "0 5px",
                "vertical-align": "middle"
              }
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  disabled: scope.row.status !== 2,
                  onClick: $event => _unref(blobDownload)(scope.row, '视频')
                }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("视频")])),
                  _: 2
                }, 1032, ["disabled", "onClick"]), scope.row.audioUrl ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: 0,
                  disabled: scope.row.status !== 2,
                  onClick: $event => _unref(blobDownload)(scope.row, '音频')
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("音频")])),
                  _: 2
                }, 1032, ["disabled", "onClick"])) : _createCommentVNode("", true), scope.row.subtitleUrl ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: 1,
                  disabled: scope.row.status !== 2,
                  onClick: $event => _unref(blobDownload)(scope.row, '字幕')
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("字幕")])),
                  _: 2
                }, 1032, ["disabled", "onClick"])) : _createCommentVNode("", true)]),
                _: 2
              }, 1024)]),
              default: _withCtx(() => [_createVNode(_unref(ElButton), {
                link: "",
                type: "primary",
                size: "small"
              }, {
                default: _withCtx(() => [_cache[25] || (_cache[25] = _createTextVNode("下载 ")), _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_Download)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 2
            }, 1024), scope.row.status == 2 ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 2,
              link: "",
              type: "success",
              size: "small",
              onClick: $event => _unref(copyItemUrl)(scope.row)
            }, {
              default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("点击复制转换链接")])),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          class: "history-table-pagination",
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "current-page": searchParams.pageIndex,
          "page-sizes": [10, 20, 50, 100],
          "page-size": searchParams.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: total.value
        }, null, 8, ["current-page", "page-size", "total"])])]), _createVNode(_component_el_dialog, {
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogVisible.value = $event),
          title: "视频预览",
          onClosed: handleClosed
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("video", {
            class: "preview-video",
            src: previewVideoUrl.value,
            controls: ""
          }, null, 8, _hoisted_20)])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: upgrade.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => upgrade.value = $event)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_image, {
            style: {
              "width": "40%"
            },
            src: require('@/assets/images/1923756.png'),
            fit: "contain"
          }, null, 8, ["src"])]), _cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "text-container"
          }, [_createElementVNode("h1", {
            class: "title"
          }, "功能维护升级"), _createElementVNode("p", {
            class: "description"
          }, "我们正在进行功能优化，以提供更好的服务体验。敬请期待！")], -1))])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
});